import { companiesService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchCompanyStats = (companyId?: string) => {
  return useQuery({
    queryKey: ['fetchCompanyStats', companyId],
    queryFn: () => companiesService.getCompanyStats(companyId || ''),
    enabled: !!companyId,
  });
};

export default useFetchCompanyStats;
